const styles = theme => ({
  page: theme.classes.page,
});

export default styles;
